import { gql } from "@apollo/client";

export const GET_AVAILABLE_COUPONS = gql`
  query AvailableCoupons($sku: String!) {
    AvailableCoupons(sku: $sku) {
      rule_id
      name
      coupon_code
      description
      from_date
      to_date
      is_active
    }
  }
`;

export default {
  getAvailableCoupons: GET_AVAILABLE_COUPONS,
};
